import { Component, Input } from '@angular/core';
import { CommonService } from '../services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { JwtService } from '../auth/jwtservice';

@Component({
  selector: 'app-site-switch',
  templateUrl: './site-switch.component.html',
  styleUrl: './site-switch.component.scss',
})
export class SiteSwitchComponent {
  options: any = [];
  selectedSiteId: any = -1;
  @Input() isVisible: boolean = true;

  constructor(
    private commonService: CommonService,
    public ngxSpinnerService: NgxSpinnerService,
    private router: Router,
    private jwtService: JwtService
  ) { }

  ngOnInit(): void {
    this.ngxSpinnerService.hide();
    var siteOptions = this.commonService.getValueFromLocalStorage('userSites');
    this.options = siteOptions ? JSON.parse(siteOptions) : this.commonService.getUserSitesFromAPI(this.commonService.getLoggedInUserId());

    //Get current site value to display in site dropdown to be selected by default
    const rawSiteId = this.commonService.getCurrentSiteId();
    this.selectedSiteId = rawSiteId ? Number(rawSiteId) : -1;
  }

  /**
   * Switches to the selected site:
   * 1. Resets selectedExploration to the first exploration of the new site
   * 2. Resets selectedProject to the first project of that exploration
   * 3. Closes the modal and navigates to /explorations so the user
   *    starts fresh on the correct screen (avoids stale data from previous site)
   */
  updateCurrentSite() {
    const resolvedSiteId = this.selectedSiteId;

    // Sync all selections: resets exploration + project for the new site
    this.commonService.syncSelectionsBySite(resolvedSiteId, true);

    // Close the modal
    this.isVisible = false;
    this.commonService.showSiteModal.next(false);

    // Navigate to the first accessible route
    const userRoles = this.jwtService.currentUserRolesValue;
    const firstAccessible = this.commonService.getFirstAccessibleSubMenu(userRoles) || '/projects';
    const navigationUrl = Array.isArray(firstAccessible) ? firstAccessible[0] : firstAccessible;
    this.router.navigate([navigationUrl]);
  }

  /**
   * Checks if valid site is selected or not. When user has selected "Please select a site then default value is "
   * @param value
   * @returns
   */
  isValidSite(value: any) {
    if (value == null || value == undefined || value < 0)
      return true
    else
      return false
  }
}
